import { CacheItemInterface } from '../../interfaces/cache-item.interface';
import { ReducerActionInterface } from '../../interfaces/reducer-action.interface';
import { addItem, removeItem, clear } from '../actions/cache.actions';

const defaultState: CacheItemInterface[] = [];

const newState = (state: CacheItemInterface[], newData: CacheItemInterface) => {
  if (newData) {
    return [...state, newData];
  }

  return state;
};

export const cacheReducer = (state: CacheItemInterface[] = defaultState, action: ReducerActionInterface) => {
  switch (action.type) {
    case addItem.type: {
      return newState(state, action.payload);
    }

    case removeItem.type: {
      const filteredState = state.filter((item) => item.requestKey !== action.payload);

      return newState(filteredState, null);
    }

    case clear.type: {
      return defaultState;
    }

    default: {
      return state;
    }
  }
};
